import React from 'react';
import { BaseInstructionScreen, List, InstructionSection } from './BaseInstructionScreen';

const ListeningInstructions = ({ onBack, onStart }) => {
  return (
    <BaseInstructionScreen
      title="TOEFL Listening Test"
      icon="🎧"
      gradientStart="#3498db"
      gradientEnd="#2980b9"
      bulletColor="#3498db"
      onBack={onBack}
      onStart={onStart}
    >
      <InstructionSection>
        <h2>Test Format</h2>
        <List bulletColor="#3498db">
          <li>4-6 lectures, 3-5 minutes each</li>
          <li>2-3 conversations, 3 minutes each</li>
          <li>28-39 questions in total</li>
          <li>60-90 minutes total time</li>
        </List>
      </InstructionSection>

      <InstructionSection>
        <h2>Important Tips</h2>
        <List bulletColor="#3498db">
          <li>Take notes while listening - they will help you answer questions</li>
          <li>Pay attention to tone of voice and emphasis</li>
          <li>Listen for main ideas and supporting details</li>
          <li>You can only listen to each audio once</li>
        </List>
      </InstructionSection>

      <InstructionSection>
        <h2>Scoring</h2>
        <List bulletColor="#3498db">
          <li>Each correct answer is worth one point</li>
          <li>No penalty for wrong answers</li>
          <li>Raw scores are converted to scaled scores (0-30)</li>
        </List>
      </InstructionSection>
    </BaseInstructionScreen>
  );
};

export default ListeningInstructions; 